import { applyGridAiSorts } from './ai-assistant'
import type { DataGrid, GridColumnInfo } from '../types'

export function useSort($grid: DataGrid) {
  const { reactData, internalData } = $grid

  $grid.handleSort = (column: GridColumnInfo, order: 'asc' | 'desc') => {
    const { sortMap } = internalData
    const { field } = column
    if (!field) {
      return
    }
    if (column.order === order) {
      column.order = null
      delete sortMap[field]
    } else {
      internalData.visibleColumns.forEach((col) => {
        if (col !== column && col.field) {
          col.order = null
          delete sortMap[col.field]
        }
      })
      column.order = order
      sortMap[field] = column
    }
    reactData.currentPage = 1
    $grid.queryByExamplePage()
  }

  $grid.getSorts = () =>
    Object.values(internalData.sortMap)
      .filter((col): col is GridColumnInfo & { order: 'asc' | 'desc' } =>
        col.order === 'asc' || col.order === 'desc'
      )
      .map(({ field, order }) => ({ field: field!, order: order! }))

  $grid.setSorts = (sorts, options) => {
    applyGridAiSorts($grid, sorts, options?.query !== false)
  }

  $grid.clearAllSort = () => {
    internalData.visibleColumns.forEach((col) => {
      col.order = null
    })
    internalData.sortMap = {}
    reactData.currentPage = 1
    $grid.queryByExamplePage()
  }
}
